<template>
  <vue-modal :active="active" @closed="$emit('closed')">
    <report-orders type="lab" ref="reportOrders">
      <template slot-scope="{report}">
        <div class="text-black mb-4 text-sm leading-none" v-for="(products, family) in report" :key="family">
          <h3 class="mb-1 text-black" v-text="family"></h3>
          <div class="break-inside-avoid border border-black mb-1" v-for="(entries, product) in products"
               :key="product">
            <div class="border-b border-black">
              <div class="p-1 flex justify-between items-center">
                <div class="flex">
                  <h4 class="text-black mr-2" v-text="product"></h4>
                  <span>(Total {{ total(entries) }})</span>
                </div>
                <div>
                  <span v-if="Object.keys(totalByShop(entries)).length">
                    (
                      <span class="mx-1" v-for="([shop, total]) in Object.entries(totalByShop(entries))">
                        <strong>{{ shop }}</strong>: {{ total }}
                      </span>
                    )
                  </span>
                  <span class="ml-4 font-bold">{{ toDo(entries) }}</span>
                </div>
              </div>
              <div>
                <div class="p-1 -mt-1 inline-block" v-for="(entry, index) in entries" :key="index"
                     v-if="entry.product.pivot.note">
                  <span
                      class="inline-block font-mono rounded-full leading-none border border-black text-white bg-black px-1 text-xs"
                      v-text="index + 1"></span>
                  <span class="text-italic">{{ entry.product.pivot.note }} x {{ entry.product.pivot.quantity }}</span>
                </div>
              </div>
            </div>
            <div class="p-1 flex flex-wrap">
              <div class="mr-2 whitespace-no-wrap inline"
                   :class="{'line-through': entry.product.pivot.prepared}"
                   v-for="(entry, index) in entries"
                   :key="index">
                <span class="inline-block leading-none rounded-full font-mono border border-black px-1 text-xs"
                      v-text="index + 1"></span>
                <span>{{ entry.order.cart.customer.name }} x {{ entry.product.pivot.quantity }}</span>
                <span class="text-xs text-italic">({{ pickup(entry) }})</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </report-orders>
  </vue-modal>
</template>

<script>
/* globals moment */

import {ucfirst} from '../../core/helpers';
import modal from '../../mixins/modal';
import ReportOrders from './ReportOrders.vue';
import {groupBy} from "lodash";

export default {
  mixins: [modal],

  components: {ReportOrders},

  methods: {
    total(entries) {
      return entries.reduce((previous, current) => previous + current.product.pivot.quantity, 0);
    },

    totalByShop(entries) {
      return entries
          .filter(entry => entry.order.shop)
          .filter(entry => !entry.product.pivot.prepared)
          .reduce((acc, entry) => {
            acc[entry.order.shop.code] = (acc[entry.order.shop.code] ?? 0) + entry.product.pivot.quantity;
            return acc;
          }, {});
    },

    toDo(entries) {
      return entries
          .filter(entry => !entry.product.pivot.prepared)
          .reduce((previous, current) => previous + current.product.pivot.quantity, 0);
    },

    pickup(entry) {
      const pickupDate = ucfirst(
          moment(entry.order.pickup_date).format('ddd DD/MM'),
      ).replace('.', '');
      const pickupTime = entry.order.pickup_time
          ? moment(entry.order.pickup_time, 'HH:mm:ss').format('HH:mm')
          : '';

      const shop = entry.order.shop ? `${entry.order.shop.code}` : '';

      return `${pickupDate} ${pickupTime} ${shop}`.trim();
    },

    refresh() {
      if (this.$refs.reportOrders) {
        this.$refs.reportOrders.refresh();
      }
    }
  },

  created() {
    Event.listen('cartUpdated', (cart) => this.refresh());
    Event.listen('orderCreated', (order) => this.refresh());
    Event.listen('orderUpdated', (order) => this.refresh());
  }
};
</script>
